import yup from "yup";
import { compose, withProps } from "recompose";
import { createStructuredSelector } from "reselect";
import { createErrorsSelector } from "core/helpers";
import { connect } from "react-redux";
import * as api from "modules/user/auth/api";
import * as selectors from "modules/user/auth/selectors";
import { unauthenticated } from "modules/user/auth/hoc";
import View from "./View";

export default compose(
  unauthenticated,
  connect(
    createStructuredSelector({
      resetPasswordApi: selectors.resetPasswordApi,
      errors: createErrorsSelector(selectors.resetPasswordApi)
    }),
    {
      onSubmit: values => api.resetPassword.request({ body: values })
    }
  ),
  withProps({
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .required("Email is required")
        .email("Is not valid email")
    })
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/ResetPass/Provider.js